import { Route, Routes } from 'react-router-dom'

import type { ConvosResult } from '../LimitedOrder'

import { useOrderContext } from './context'

import Messages from '@/buyers/pages/StoreOrder/Messages'

const OrderMessages = ({ convosResult }: { convosResult: ConvosResult }) => {
  const { org, internalVendor, refetchStoreOrder } = useOrderContext()

  return (
    <Routes>
      <Route
        path=""
        element={
          <Messages
            org={org}
            convosResult={convosResult}
            refetchStoreOrder={refetchStoreOrder}
            internalVendor={internalVendor}
          />
        }
      />
      <Route
        path=":conversationId"
        element={
          <Messages
            org={org}
            convosResult={convosResult}
            refetchStoreOrder={refetchStoreOrder}
            internalVendor={internalVendor}
          />
        }
      />
      <Route
        path="store/:storeId"
        element={
          <Messages
            org={org}
            convosResult={convosResult}
            refetchStoreOrder={refetchStoreOrder}
            internalVendor={internalVendor}
          />
        }
      />
      <Route
        path="internalOrg"
        element={
          <Messages
            org={org}
            convosResult={convosResult}
            refetchStoreOrder={refetchStoreOrder}
            internalOrg
            internalVendor={internalVendor}
          />
        }
      />
    </Routes>
  )
}

export default OrderMessages
